import { AsyncPipe, NgFor, NgIf } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterLink } from '@angular/router';
import { CustomUserCmsComponents } from '@core/const';
import { SdAddCompanyButtonModule } from '@sdvor/company/ui';
import {
  CollapsibleTextComponent,
  SdvorButtonComponent,
  SdvorLinkComponent,
  SdvorTabBarItemComponent,
} from '@sdvor/shared/ui';
import { BonusWidgetComponent } from '@sdvor/shared/ui/v2';
import { CmsConfig, ConfigModule, UrlModule } from '@spartacus/core';
import { PageSlotModule } from '@spartacus/storefront';
import { LoginButtonComponent } from './login-button.component';
import { DesktopLoginButtonComponent } from './views/desktop/desktop-login-button.component';
import { MobileLoginButtonComponent } from './views/mobile/mobile-login-button.component';

@NgModule({
  declarations: [LoginButtonComponent, DesktopLoginButtonComponent, MobileLoginButtonComponent],
  imports: [
    NgIf,
    NgFor,
    AsyncPipe,
    RouterLink,
    PageSlotModule,
    SdAddCompanyButtonModule,
    SdvorButtonComponent,
    SdvorLinkComponent,
    SdvorTabBarItemComponent,
    UrlModule,
    CollapsibleTextComponent,
    BonusWidgetComponent,
    ConfigModule.withConfig(<CmsConfig>{
      cmsComponents: {
        [CustomUserCmsComponents.SdCMSLoginButtonComponent]: {
          component: LoginButtonComponent,
        },
      },
    }),
  ],
  exports: [LoginButtonComponent],
})
export class LoginButtonModule {}
